var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangleIcon = function SvgAlertTriangleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.933 15.993.515 8.75c.03.495.44.882.936.882h3.232a.938.938 0 0 0 .936-.882l.515-8.75A.938.938 0 0 0 25.13 15h-4.262a.938.938 0 0 0-.936.993ZM26.281 30a3.281 3.281 0 1 1-6.562 0 3.281 3.281 0 0 1 6.562 0Zm-.033-28.126c-1.44-2.496-5.053-2.5-6.496 0L1.006 34.376C-.434 36.871 1.369 40 4.254 40h37.491c2.88 0 4.69-3.124 3.248-5.624L26.248 1.874ZM4.656 35.547 22.594 4.454a.469.469 0 0 1 .812 0l17.938 31.093a.469.469 0 0 1-.406.703H5.063a.469.469 0 0 1-.406-.703Z",
    fill: "#fff"
  })));
};
export default SvgAlertTriangleIcon;